import React, { Component } from 'react';
import { Popconfirm, Popover, Button, Spin, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import { ModifyManhour } from './Widget';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const monthFormat = 'YYYY-MM';

class Filter extends Component {

    disabledDate = (current) => {
        const { currentDate } = this.props;
        const curNum = Number(current.format('YYYYMMDD'));
        const startNum = Number(moment(currentDate).add(-3, 'M').startOf('month').format('YYYYMMDD'));
        return curNum < startNum
    }

    render() {
        const { workType, workContent, params, ...rest } = this.props;
        const { siteId, curRole } = sessionStorage;
        const filters = [{
            name: '工作日期',
            key: 'startDate',
            type: 'rangePicker',
            typeProperty: {
                keys: ['startDate', 'endDate'],
                disabledDate: curRole === 'CRC' ? this.disabledDate : undefined,
            },
        }, {
            name: '工作类型',
            key: 'enterpriseWorkNameId',
            type: 'select',
            typeProperty: {
                style: { width: 120 },
                list: workType,
            }
        }, {
            name: '工作内容',
            key: 'workTypeId',
            type: 'select',
            typeProperty: {
                style: { width: 160 },
                list: workContent,
                disabled: !params['enterpriseWorkNameId'],
            }
        }, {
            name: '状态',
            key: 'workStatus',
            type: 'select',
            typeProperty: {
                style: { width: 120 },
                list: [
                    { label: '未确认', value: 'UNVERIFY' },
                    { label: '未确认(待修改)', value: 'UNVERIFY_UNHAND' },
                    { label: '未确认(已修改)', value: 'UNVERIFY_HANDED' },
                    { label: '已确认', value: 'VERIFY' },
                ],
            }
        }];
        if (siteId == 0) {
            filters.push({
                name: '中心',
                key: 'investigationSite',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'searchKey',
                    style: {width: 160},
                    placeholder: '输入中心编号/名称检索',
                    params: {limit: 20},
                    url: API_URL.site.list,
                    config: { id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'site' },
                }
            });
        }
        filters.push({
            name: '录入者',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.team.userlist,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            }
        });
        return (
            <FilterBasic filters={filters} params={params} {...rest} />
        )
    }
}

class Detail extends Component {
    constructor(props) {
        super(props);
        const { siteId } = sessionStorage;
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams: {
                investigationSiteId: siteId > 0 ? siteId : '',
                startDate: `${moment().subtract(1, 'M').format(monthFormat)}-26`,
                endDate: `${moment().format(monthFormat)}-25`,
            },
            pagination: {
                pageSize: 10,
                current: 1,
            },
            workType: [],
            workContent: [],
            currentDate: '',
        };
    }

    componentDidMount() {
        this.loadData();
        this.queryWorkType();
        this.queryInvestigationStageByInvId();
        this.getDate();
    }

    getDate = () => {
        const options = {
            method: 'POST',
            url: API_URL.home.queryEffectiveDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                this.setState({ currentDate: date });
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.manhour.queryManHourList,
            data: {
                offset: current,
                limit: pageSize - 1,
                ...sortParams,
                ...params,
                isRelateInvestigation: '1',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount + ((totalCount / (pageSize - 1)) | 0);
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    delete = (manHourId) => {
        const options = {
            method: 'POST',
            url: API_URL.manhour.delmanhour,
            data: { 
                manHourId, 
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.data.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    queryWorkType = () => {
        const { invId } = sessionStorage;
        const options = {
            url: API_URL.manhour.queryEnterpriseNameById,
            data: {
                isRelateInvestigation: '1',
                investigationId: invId,
                needAllCategroy: '1',
            },
            dataType: 'json',
            doneResult: res => {
                const workType = (res.data || []).map(i => ({ label: i.enterpriseWorkNameValue, value: i.enterpriseWorkNameId }));
                this.setState({ workType });
            }
        };
        $.sendRequest(options);
    }

    queryWorkContent = () => {
        const { searchParams } = this.state;
        const { enterpriseWorkNameId } = searchParams;
        const options = {
            url: API_URL.manhour.queryInvestigationEnterpriseWorkName,
            data: {
                isRelateInvestigation: '1',
                enterpriseWorkNameId: enterpriseWorkNameId,
            },
            dataType: 'json',
            doneResult: res => {
                const workContent = (res.data || []).map(i => ({ label: `${i.enterpriseWorkTypeName}(${i.enterpriseWorkTypeCode})`, value: i.enterpriseWorkTypeId }));
                this.setState({ workContent });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const params = this.splitParams(searchParams);
        const url = API_URL.export.exportManHourList;
        ExportUtil.export({ ...sortParams, ...params }, pagination, url);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams, key) => {
        this.setState({ searchParams }, () => {
            if (key === 'enterpriseWorkNameId' && searchParams['enterpriseWorkNameId']) {
                this.queryWorkContent();
            }
        });
    }

    getRender = (text, record) => {
        const { dateValue } = record;
        if (dateValue !== '总计') {
            return text || '-';
        }
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }


    getColumns = () => {
        const columns = [{
            title: '工作日期',
            dataIndex: 'manHourDateString',
            key: 'manHourDateString',
            sorter: true,
            width: 90,
        }, {
            title: '录入者',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '录入者工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            width: 80,
            render: this.getRender,
        },{
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
            render: this.getRender,
        }, {
            title: '工作类型',
            dataIndex: 'enterpriseWorkNameValue',
            key: 'enterpriseWorkNameValue',
            width: 80,
        }, {
            title: '工作内容(编号)',
            dataIndex: 'enterpriseWorkTypeString',
            key: 'enterpriseWorkTypeString',
            width: 160,
        }, {
            title: '用时',
            dataIndex: 'durationString',
            key: 'durationString',
            width: 60,
            render: (text, record) => {
                const { remarks, manHourVisitTip, enterpriseWorkNameValue } = record;
                const obj = { children: text };
                if (manHourVisitTip) {
                    const list = manHourVisitTip.split(';');
                    const node = list.map((item, index) => <div key={index}>{item}</div>);
                    obj.children = (
                        <Popover placement="right" overlayClassName="gray-pop" content={node}>
                            <div>
                                <i className='pop'></i>
                                {text}
                            </div>
                        </Popover>
                    );
                }
                if (remarks) {
                    const len = Math.ceil(remarks.length / 10);
                    const node = [];
                    for (let i = 0; i < len; i++ ) {
                        node.push(<p key={i}>{remarks.slice(i * 10, (i + 1) * 10)}</p>);
                    }
                    obj.children = (
                        <Popover placement="right" overlayClassName="gray-pop" content={node}>
                            <div>
                                <i className='pop'></i>
                                {text}
                            </div>
                        </Popover>
                    );
                }
                return enterpriseWorkNameValue !== '患者访视' ? text : obj;
            }
        }, {
            title: '备注',
            dataIndex: 'remarks',
            key: 'remarks',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'realManHourStatusShow',
            key: 'realManHourStatusShow',
            width: 100,
        }];
        const { userId, curRole } = sessionStorage;
        if (curRole == 'CRC' || curRole == 'PM' || curRole == 'PA'){
            columns.push({
                title: '操作',
                key: 'operation',
                width: 80,
                render: (text, record) => {
                    const { realManHourStatus :status   , manHourId, userId: rUserId } = record;
                    if (curRole == 'CRC') {
                        return (                          
                            (manHourId > 0 && status != 'VERIFY') ?
                                <span>
                                    <a onClick={()=> this.canEditByInvStatus(() => this.showModifyManhour(record))}>修改</a>
                                    <span className="ant-divider" />
                                    <Popconfirm title='确定删除该工时记录？' onConfirm={()=> this.canEditByInvStatus(() => this.delete(manHourId))} okText="确定" cancelText="取消">
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                            :
                                '-'
                        );
                    } else if (curRole == 'PM') {
                        return (                          
                            (manHourId > 0 && status === 'UNVERIFY' && userId == rUserId) ?
                                <span>
                                    <a onClick={()=> this.canEditByInvStatus(() => this.showModifyManhour(record))}>修改</a>
                                    <span className="ant-divider" />
                                    <Popconfirm title='确定删除该工时记录？' onConfirm={()=> this.canEditByInvStatus(() => this.delete(manHourId))} okText="确定" cancelText="取消">
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                            :
                                '-'
                        );
                    }
                },
            });
        }
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showModifyManhour = (record) => {
        this.modifyManhourRef.show(record);
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams, workType, workContent, currentDate } = this.state;
        const { curRole } = sessionStorage;
        return (
            <div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    workType={workType}
                    workContent={workContent}
                    onChange={this.handleFilterChange}
                    currentDate={currentDate}
                    buttons={[
                        curRole != 'CRC' && <Button key="export" type="primary" onClick={this.export}>导出</Button>
                    ]}
                />
                <Spin spinning={loading}>
                    <TableC
                        data={data}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </Spin>
                <ModifyManhour ref={el => this.modifyManhourRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default Detail;


// WEBPACK FOOTER //
// ./src/components/execute/manHour/Detail.js